import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { Exercise, Organisation, Event, News, Leader } from '../../../models/types';
import { LoginService } from '../../services/login.service';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';
import { CommonModule } from '@angular/common';
import { exercises } from '../../../assets/images/organisations/sports/exercises';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { imageLocation } from '../../../environments/environment.development';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHouse, faEnvelope, faPhone, faUserPlus, faMountain, faRocket, faFlagCheckered, faChartSimple, faRuler, faPerson, faPersonRunning, faUserTie, faTrash, faPlus, faGift } from '@fortawesome/free-solid-svg-icons';
import { EventService } from '../../services/event.service';
import { EventListComponent } from '../event-list/event-list.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NewsListComponent } from '../news-list/news-list.component';
import { GalleryImage, GalleryItemEvent, GalleryModule } from '@daelmaak/ngx-gallery';
import { Hot100PrijavaComponent } from '../hot100-prijava/hot100-prijava.component';
import { MapComponent } from '../map/map.component';
import { AddEventComponent } from '../add-event/add-event.component';
import { FormsModule } from '@angular/forms';
import { SlidingBackgroundComponent } from "../sliding-background/sliding-background.component";
import { ProfilePageService } from '../../services/profile-page.service';
import Swal from 'sweetalert2';
import { HttpResponse } from '@angular/common/http';
import { ReportListComponent } from '../report-list/report-list.component';
import { FriendshipRacePrijavaComponent } from "../friendship-race-prijava/friendship-race-prijava.component";
import { VarstvoPrijavaComponent } from '../varstvo-prijava/varstvo-prijava.component';
import { ProgeComponent } from '../proge/proge.component';
import { Cold50PrijavaComponent } from '../cold50-prijava/cold50-prijava.component';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-sports-profile-page',
  standalone: true,
  imports: [
    AnimateOnScrollModule,
    CommonModule, 
    FormsModule, 
    AddEventComponent, 
    FontAwesomeModule, 
    EventListComponent, 
    MapComponent, 
    NewsListComponent, 
    GalleryModule, 
    Hot100PrijavaComponent, 
    SlidingBackgroundComponent, 
    ReportListComponent, 
    FriendshipRacePrijavaComponent, 
    VarstvoPrijavaComponent,
    ProgeComponent,
    RouterModule,
    Cold50PrijavaComponent
  ],
  templateUrl: './sports-profile-page.component.html',
  styleUrl: './sports-profile-page.component.scss',
  encapsulation: ViewEncapsulation.None // This can affect styles
})
export class SportsProfilePageComponent implements AfterViewInit{

  @Input() organisation: Organisation | null = null;
  @Input() isSuperAdmin: boolean = false;
  @Output() leaderAdded = new EventEmitter<void>();

  news: News[] = [];
  isOrgAdmin: boolean = false;
  isLoading: boolean = true;
  error: string | null = null;

  exercises: Exercise[] = [];
  hot100Exists = false;
  tekPrijatelstvaExists = false;
  hot100date = '';
  tekPrijateljstvaDate = '';
  showTekPrijava = false;
  showAddExerciseForm: boolean = false;
  varstvoExists = false;
  showVarstvoPrijava = false;
  currentPage: number = 1;
  pageSize: number = 4;
  totalItems: number = 0;
  varstvoStartDate = '';
  varstvoEndDate = '';
  cold50Exists = false;
  showCold50prijava = false;

  JoinFileUrl = `${imageLocation}/static/content/sports/pristopna_izjava.pdf`;
  LeaveFileUrl = `${imageLocation}/static/content/sports/izstopna_izjava.pdf`;

  faHouse = faHouse;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faUserPlus = faUserPlus;
  faMountain = faMountain;
  faRocket = faRocket;
  faFlagCheckered = faFlagCheckered;
  faChartSimple = faChartSimple;
  faRuler = faRuler;
  faPersonRunning = faPersonRunning;
  faUserTie = faUserTie;
  faTrash = faTrash;
  faPlus = faPlus;
  faGift = faGift

  allEvents: Event[] = [];
  organisationId!: string;
  imageFile: File | undefined;
  previewImageSrc: string | ArrayBuffer | null = null;
  
  sportsImages: GalleryImage[] = [];
  selectedImageIndex= -1;
  imageSelected = false;
  showHot100prijava = false;
  menuOpen = false;
  isEditExerciseMode = false;
  editExerciseId: number | null = null;
  imageChanged = false;

  newLeader: Leader = {
    leaderID: 0,
    role: '',
    name: '',
    email: '',
    phone: '',
    imageRef: '',
    organisationID: 0
  };

  newExercise: Exercise = {
    exerciseID: 0,
    name: '',
    description: '',
    schedule: '',
    cost: '',
    leader: '',
    leaderPhone: '',
    trainers: [],
    imageUrl: ''
  };
  showVanRentalForm = false;

  vanRental = {
    name: '',
    email: '',
    phone: '',
    startDate: '',
    relation: '',
    endDate: '',
    description: ''
  };

  isVanSending = false;
  currentYear: number = new Date().getFullYear();
  //currentYear: number = 2026;

  childrenCategories = [
    { name: "Netekmovalen", minAge: 0, maxAge: 5, distance: "250m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_300.pdf` },
    { name: "A", minAge: 6, maxAge: 7, distance: "300m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_300.pdf` },
    { name: "B", minAge: 8, maxAge: 8, distance: "300m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_300.pdf` },
    { name: "C", minAge: 9, maxAge: 9, distance: "600m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_600.pdf` },
    { name: "D", minAge: 10, maxAge: 10, distance: "600m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_600.pdf` },
    { name: "E", minAge: 11, maxAge: 11, distance: "1000m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_1000.pdf` },
    { name: "F", minAge: 12, maxAge: 12, distance: "1000m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_1000.pdf` },
    { name: "G", minAge: 13, maxAge: 13, distance: "1000m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_1000.pdf` },
    { name: "H", minAge: 14, maxAge: 15, distance: "2000m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_1000.pdf` }
  ];

  recreationalCategories = [
    { name: "A", minAge: 0, maxAge: 20, distance: "4.8 km", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_4800.pdf` },
    { name: "B", minAge: 21, maxAge: 40, distance: "4.8 km", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_4800.pdf` },
    { name: "C", minAge: 41, maxAge: 100, distance: "4.8 km", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_4800.pdf` }
  ]

  // Grownups categories (Men)
  grownupsMenCategories = [
    { name: "ČI-A", minAge: 16, maxAge: 29, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf`},
    { name: "ČI-B", minAge: 30, maxAge: 39, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČI-C", minAge: 40, maxAge: 49, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČI-D", minAge: 50, maxAge: 59, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČI-E", minAge: 60, maxAge: 100, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` }
  ];

  grownupsWomenCategories = [
    { name: "ČE-F", minAge: 16, maxAge: 29, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČE-G", minAge: 30, maxAge: 39, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČE-H", minAge: 40, maxAge: 49, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` },
    { name: "ČE-I", minAge: 50, maxAge: 100, distance: "11800m", link: `${imageLocation}/static/content/sports/tek_trails/PROGA_11517.pdf` }
  ];

  hot100Images = Array.from({ length: 10 }, (_, index) => {
    const imageNumber = index + 1;
    return new GalleryImage(
      `../../../assets/images/organisations/sports/hot100/${imageNumber}.jpg`,
      `../../../assets/images/organisations/sports/hot100/${imageNumber}.jpg`
    );
  });

  varstvoImages = Array.from({ length: 13 }, (_, index) => {
    const imageNumber = index + 1;
    return new GalleryImage(
      `../../../assets/images/organisations/sports/varstvo/${imageNumber}.jpg`,
      `../../../assets/images/organisations/sports/varstvo/${imageNumber}.jpg`
    );
  });

  tekImages = Array.from({ length: 7 }, (_, index) => {
    const imageNumber = index + 1;
    return new GalleryImage(
      `../../../assets/images/organisations/sports/tek/${imageNumber}.jpg`,
      `../../../assets/images/organisations/sports/tek/${imageNumber}.jpg`
    );
  });


  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private organisationService: OrganisationServiceService,
    private eventService: EventService,
    private profilePageService: ProfilePageService
  ) { }


  
  ngOnInit() {
    this.isOrgAdmin = this.loginService.IsOrgAdminLoggedIn("sport") 
    this.extractOrganisationIdFromName();
    this.handleScroll();
  }

  ngAfterViewInit() {
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.scrollToAnchor(fragment);
      }
    });
  }
  private scrollToAnchor(fragment: string) {
    let attempts = 0;

    const tryScroll = () => {
      const element = document.getElementById(fragment);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else if (attempts < 15) {
        attempts++;
        setTimeout(tryScroll, 100); // wait for async DOM
      }
    };

    setTimeout(tryScroll, 50);
  }

  extractOrganisationIdFromName() {
    this.organisationService.getOrganisationIdByName("Športno Društvo Hotedršica").subscribe({
      next: (response) => {
        this.organisationId = response.body?.organisationID.toString() || '';
        this.loadEvents();
        this.getNews();
        this.fetchOrgImages();
        this.getExercises();
      },
      error: (err) => {
        console.error('Error extracting organisation ID:', err);
      }
    });
  }


  getExercises() {
    this.organisationService.getExercises().subscribe({
      next: (response) => {
        this.exercises = response;
        this.exercises = this.assignExerciseImages(this.exercises);
        console.log('Exercises:', this.exercises);
      },
      error: (err) => {
        console.error('Failed to fetch exercises:', err);
      }
    });
  }

  fetchOrgImages() {
    this.organisationService.getOrganisationImages(this.organisation!.organisationID).subscribe({
      next: (response) => {
        this.sportsImages = response.body?.images.map((image: any) => {
          return new GalleryImage(
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
          );
        }) || []; // Fallback to empty array if response.body is null
      },
      error: (err) => {
        console.error('Failed to fetch organisation images:', err);
      }
    });
  }  

  extractOrganisationId() {
    this.route.paramMap.subscribe(params => {
      this.organisationId = params.get('orgID')!;
    });
  }

  loadEvents() {
    this.eventService.getAllEvents().subscribe((response) => {
      this.allEvents = response.events!.filter((event: Event) => event.organisationID === Number(this.organisationId));

      const hot100Event = this.allEvents.find((event) =>
        event.title.toLowerCase().replace(/\s+/g, "").includes("hot100")
      );
      if (hot100Event) {
        this.hot100Exists = true;
        this.hot100date = hot100Event.start;
      }

      const varstvoEvent = this.allEvents.find((event) =>
        event.title.toLowerCase().replace(/\s+/g, "").includes("hotenjskišportniteden")
      );

      if (varstvoEvent) {
        this.varstvoExists = true;
        this.varstvoStartDate = varstvoEvent.start;
        this.varstvoEndDate = varstvoEvent.end;
      }

      const tekPrijatelstvaEvent = this.allEvents.find((event) =>
        event.title.toLowerCase().replace(/\s+/g, "").includes("tekprijateljstva")
      );
      if (tekPrijatelstvaEvent) {
        this.tekPrijatelstvaExists = true;
        this.tekPrijateljstvaDate = tekPrijatelstvaEvent.start;
      } else {
        this.tekPrijatelstvaExists = false;
      }

      const cold50Event = this.allEvents.find((event) =>
        event.title.toLowerCase().replace(/\s+/g, "").includes("cold50")
      );
      if (cold50Event) {
        this.cold50Exists = true;
      } else {
        this.cold50Exists = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  handleScroll() {
    const images = document.querySelectorAll('.animated-image') as NodeListOf<HTMLElement>;
    const titles = document.querySelectorAll('.animated-title') as NodeListOf<HTMLElement>;
    const texts = document.querySelectorAll('.animated-text') as NodeListOf<HTMLElement>;

    this.animateOnScroll(images, 'left-image', 'slide-in-left');
    this.animateOnScroll(images, 'right-image', 'slide-in-right');
    this.animateOnScroll(titles, '', 'slide-in-left'); // No specific class, so we just add the animation
    this.animateOnScroll(texts, '', 'slide-in-right'); // No specific class, just add the animation
  }

  private animateOnScroll(elements: NodeListOf<HTMLElement>, className: string, animationClass: string) {
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        if (className === '' || element.classList.contains(className)) {
          element.classList.add(animationClass);
        }
      }
    });
  }

  openExerciseModal(exercise: Exercise) {
    event?.preventDefault();
    this.organisationService.openExerciseModal(exercise);
  }

  openJoinFile(): void {
    // Open the file in a new tab
    window.open(this.JoinFileUrl, '_blank');
  }

  openLeaveFile(): void {
    // Open the file in a new tab
    window.open(this.LeaveFileUrl, '_blank');
  }

  private assignNewsImages(news: News[]): News[] {
    return news.map(newsItem => {
      let defaultImageUrl = '../../../assets/images/generic/news.png';
      newsItem.imageRef = newsItem.imageRef ?
      `${imageLocation}/static/content/news/${newsItem.newsID}/${newsItem.imageRef}` :
      defaultImageUrl;
      return newsItem;
    })
  }

  // Fetch news from the service
  getNews() {
    this.isLoading = true;
  
    this.organisationService.getPaginatedNews(this.currentPage, this.pageSize, this.organisationId).subscribe({
      next: (response) => {
        if (response && Array.isArray(response.news)) {
          const newNews = this.assignNewsImages(response.news);
          this.news = [...this.news, ...newNews]; // Append, don't replace
          this.totalItems = response.total;
        } else {
          this.news = [];
        }
  
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load news.';
        this.isLoading = false;
      }
    });
  }
  

loadMoreNews() {
  this.currentPage++;
  this.getNews(); // will use the updated page
}

  
  onThumbClick(event: GalleryItemEvent) {
    this.selectedImageIndex = event.index;
    this.imageSelected = true;
    console.log(`Selected image index: ${this.selectedImageIndex}`);
  }

  onPrijavaClicked() {
    this.showHot100prijava = true;
  }

  onTekPrijavaClicked() {
    this.showTekPrijava = true;
  }

  OnCold50ZapriClicked() {
    this.showCold50prijava = false;
  }

  onCold50PrijavaClicked() {
    this.showCold50prijava = true;
  }

  onVarstvoPrijavaClicked() {
    this.showVarstvoPrijava = true;
  }

  OnZapriClicked() {
    this.showHot100prijava = false;
  }
  OnTekZapriClicked() {
    this.showTekPrijava = false;
    setTimeout(() => this.scrollTo('tek-prijateljstva'), 50);
  }

  OnVarstvoZapriClicked() {
    this.showVarstvoPrijava = false;
    setTimeout(() => this.scrollTo('varstvo'), 50);
  }


  deleteLeader(id: number) {
    this.organisationService.deleteLeader(id).subscribe({
      next: (response) => {
        console.log('Leader deleted:', response);
        //window.location.reload();
      },
      error: (err) => {
        console.error('Error deleting leader:', err);
      }
    });
  } 

  onSubmitAddLeader() {
    this.newLeader.organisationID = parseInt(this.organisationId);
    if (this.newLeader.name && this.newLeader.role && this.newLeader.email && this.newLeader.phone && this.newLeader.organisationID) {
      this.organisationService.addLeader(this.newLeader).subscribe({
        next: (response) => {
          this.newLeader = { leaderID: 0, role: '', name: '', email: '', phone: '', imageRef: '', organisationID: 0 };
          Swal.fire({
            title: 'Uspešno dodano!',
            text: 'Vodja uspešno dodan! Prosimo, osvežite stran, da vidite spremembe.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        },
        error: (error) => {
          console.error('Error adding leader:', error);
        }
      });
    } else {
      console.log('Please fill in all required fields.');
    }
  }

  openAddSportsImagesModal() {
    this.profilePageService.openOrgImageAddModal(this.organisation!);  
  }

  deleteSelectedImage() {
    if (this.selectedImageIndex !== null) {
      Swal.fire({
        title: 'Ali želite nadaljevati?',
        text: 'Ali želite izbrisati sliko?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da, izbriši!',
        cancelButtonText: 'Ne, prekliči!'
      }).then((result) => {
        if (result.isConfirmed) {
          const imageToDelete = this.sportsImages[this.selectedImageIndex];
          const pictureSrc = imageToDelete.src;
  
          this.organisationService.deleteOrgImage(Number(this.organisationId), pictureSrc).subscribe({
            next: (response: HttpResponse<any>) => {
              console.log('Image deleted successfully:', response);
              this.sportsImages.splice(this.selectedImageIndex, 1); // Remove image from the gallery
              this.selectedImageIndex = -1;
              this.imageSelected = false;
              this.fetchOrgImages(); // Fetch updated images
            },
            error: (err) => {
              console.error('Failed to delete image:', err);
            }
          });
        } else {
          console.log('Image deletion cancelled');
        }
      });
    } else {
      console.log('No image selected for deletion');
    }
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  
  scrollTo(sectionId: string) {
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;
  
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
      this.menuOpen = false;
    }, 50);
  }

  formatYearRange(startYear: number, endYear: number): string {
  
    if (typeof startYear !== 'number' || typeof endYear !== 'number') {
      return 'Invalid input';
    }
  
    // Case where startYear equals endYear (only one year is present)
    if (startYear === endYear) {
      return `${startYear}`;
    }
  
    // Check for the special cases:
    // Case for startYear == 0 (replace it with "in mlajši")
    if (startYear === 0) {
      console.log('Special case: startYear === 0');
      return `${endYear} in mlajši`;
    }
  
    // Case for startYear == 1900 (replace it with "in starejši")
    if (startYear === 1900) {
      return `${endYear} in starejši`;
    }
  
    // Case for endYear == 1900 (replace it with "in starejši")
    if (endYear === 1900) {
      return `${startYear} in starejši`;
    }
  
    // Default case for a year range
    return `${startYear} - ${endYear}`;
  }

  getEligibleYearsForChildren(category: any): string {
    const startYear = this.currentYear - category.maxAge;
    const endYear = this.currentYear - category.minAge;
    return this.formatYearRange(startYear, endYear);
  }

  getEligibleYearsForRecreational(category: any): string {
    const startYear = this.currentYear - category.maxAge;
    const endYear = this.currentYear - category.minAge;
    return this.formatYearRange(startYear, endYear);
  }

  getEligibleYearsForGrownups(category: any): string {
    const startYear = this.currentYear - category.maxAge;
    const endYear = this.currentYear - category.minAge;
    return this.formatYearRange(startYear, endYear);
  }

  handleEventAdded() {
    this.allEvents = [];
    this.currentPage = 1;
    this.loadEvents();
  }

  handleNewsChanged() {
    console.log('News changed, refreshing list...');
    this.news = [];
    this.currentPage = 1;
    this.getNews();
  }

  saveExercise() {
    if (
      !this.newExercise.name ||
      !this.newExercise.description ||
      !this.newExercise.schedule ||
      !this.newExercise.cost ||
      !this.newExercise.leader ||
      !this.newExercise.leaderPhone ||
      !this.newExercise.trainers
    ) {
      Swal.fire('Napaka', 'Vsa polja so obvezna!', 'error');
      return;
    }

    if (this.isEditExerciseMode) {
      // --- UPDATE EXISTING EXERCISE ---
      this.newExercise.imageUrl = this.newExercise.imageUrl?.split('/').pop() ?? '';
      this.organisationService.updateExercise(this.newExercise).subscribe({
        next: (response) => {
          if (response && response.message !== 'Error updating exercise') {
            Swal.fire('Uspeh', 'Vadba uspešno posodobljena', 'success');
            if (this.imageFile && this.imageChanged) {
              this.updateExerciseImage(this.newExercise.exerciseID);
              this.imageChanged = false;
            } else {
              this.resetAndCloseModal();
            }
          } else {
            Swal.fire('Napaka', 'Posodobitev vadbe ni uspela', 'error');
          }
        },
        error: (err) => {
          console.error('Error updating exercise:', err);
          Swal.fire('Napaka', 'Pri posodobitvi vadbe je prišlo do napake', 'error');
        },
      });

    } else {
      // --- ADD NEW EXERCISE ---
      this.organisationService.addExercise(this.newExercise).subscribe({
        next: (response) => {
          Swal.fire('Uspeh', 'Vadba uspešno dodana', 'success');
          const exerciseID = response.exercise_id;
          if (this.imageFile) {
            this.uploadImageFile(exerciseID);
          } else {
            this.resetAndCloseModal();
          }
        },
        error: (err) => {
          console.error('Error adding exercise:', err);
          Swal.fire('Napaka', 'Dodajanje vadbe ni uspelo', 'error');
        },
      });
    }
  }


  onImageUploadChanged(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.imageChanged = true;
      this.organisationService.compressImage(file, 70, 70).then((compressedFile) => {
        this.imageFile = compressedFile;
        this.previewImageSrc = URL.createObjectURL(compressedFile);
      }).catch(error => console.error('Error compressing image:', error));
    }
  }
 
  uploadImageFile(exerciseID: number): void {
    this.organisationService.uploadImageFile({
      picture: this.imageFile!,
      exerciseID: exerciseID
    }).subscribe({
      next: (data) => {
        this.newExercise.imageUrl = data.imageURL; // Assuming response contains the image URL or path
        this.resetAndCloseModal();
      },
      error: (error) => {
        console.error('Error uploading image:', error);
      }
    });
  }

  updateExerciseImage(exerciseID: number): void {
    this.organisationService.updateExerciseImage({
      picture: this.imageFile!,
      exerciseID: exerciseID
    }).subscribe({
      next: (data) => {
        this.newExercise.imageUrl = data.imageURL; // Assuming response contains the image URL or path
        this.resetAndCloseModal();
      },
      error: (error) => {
        console.error('Error uploading image:', error);
      }
    });
  }

  resetAndCloseModal(): void {
    this.newExercise = {
      exerciseID: 0,
      name: '',
      description: '',
      schedule: '',
      cost: '',
      leader: '',
      leaderPhone: '',
      trainers: [],
      imageUrl: ''
    };
    this.isEditExerciseMode = false;
    this.showAddExerciseForm = false;
    this.previewImageSrc = null;
    this.imageFile = undefined;

    this.getExercises();
  }
 
  assignExerciseImages(exercises: Exercise[]): Exercise[] {
    return exercises.map(exercise => {
      let defaultImageUrl = '../../../assets/images/generic/exercise.png';
      exercise.imageUrl = exercise.imageUrl ?
        `${imageLocation}/static/content/sports/exercises/${exercise.exerciseID}/${exercise.imageUrl}` :
        defaultImageUrl;
      return exercise;
    });
  }

  deleteExercise(exerciseID: number) {
    this.organisationService.deleteExercise(exerciseID).subscribe({
      next: (response) => {
        Swal.fire({
          title: 'Vadba uspešno izbrisana',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500
        });
        this.getExercises();
      },
      error: (error) => {
        console.error('Error deleting exercise:', error);
      }
    });
  }
  submitVanRental() {
    this.isVanSending = true;
  
    this.organisationService.sendVanRental(this.vanRental).subscribe({
      next: () => {
        Swal.fire({
          title: 'Uspeh!',
          text: 'Rezervacija kombija uspešno poslana!',
          icon: 'success',
          confirmButtonText: 'V redu'
        });
        this.showVanRentalForm = false;
        this.isVanSending = false;
        this.vanRental = { name: '', email: '', phone: '', startDate: '', relation: '', endDate: '', description: '' };
      },
      error: (err) => {
        console.error('Napaka pri pošiljanju rezervacije:', err);
        Swal.fire({
          title: 'Napaka!',
          text: 'Napaka pri pošiljanju. Poskusite znova.',
          icon: 'error',
          confirmButtonText: 'V redu'
        });
        this.isVanSending = false;
      }
    });
  }

  editExercise(exercise: Exercise) {
    this.isEditExerciseMode = true;
    this.showAddExerciseForm = true;
    this.editExerciseId = exercise.exerciseID;

    this.newExercise = {
      exerciseID: exercise.exerciseID,
      name: exercise.name,
      description: exercise.description,
      schedule: exercise.schedule,
      cost: exercise.cost,
      leader: exercise.leader,
      leaderPhone: exercise.leaderPhone,
      trainers: exercise.trainers,
      imageUrl: exercise.imageUrl
    };

    this.previewImageSrc = exercise.imageUrl ? exercise.imageUrl : null;
  }
}
